import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import CircularProgress from "@material-ui/core/CircularProgress";

export class IsLoading extends Component {
  render() {
    const { is_loading } = this.props;
    return (
      <React.Fragment>
        {is_loading ? (
          <Modal
            isOpen={is_loading}
            className="isLoading"
            style={{ paddingTop: "100px" }}
          >
            <ModalHeader>Loading...</ModalHeader>
            <ModalBody>
              <div style={{ width: "10%", margin: "0 auto" }}>
                <CircularProgress></CircularProgress>
              </div>
            </ModalBody>
          </Modal>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  is_loading: state.isLoading.is_loading,
});

export default connect(mapStateToProps)(IsLoading);
